import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { BRAND, IMG, whatsappLink } from "../lib/constants";

export default function Hero() {
    return (
        <section
            id="home"
            className="relative min-h-screen w-full overflow-hidden flex items-center justify-center"
            data-testid="hero-section"
        >
            <img
                src={IMG.heroNightPool}
                alt="Veeras Resorts night pool"
                className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/65" />

            <div className="relative z-10 w-full max-w-6xl mx-auto px-6 md:px-10 text-center flex flex-col items-center">
                <p
                    className="text-cream/80 text-xs sm:text-sm md:text-base italic font-serif tracking-wide mb-5 md:mb-7 animate-fade-up"
                    data-testid="hero-tagline"
                >
                    A homestay tucked inside a coffee estate
                </p>

                <h1
                    className="font-serif text-white font-normal leading-[1.05] tracking-tight text-[34px] sm:text-5xl md:text-6xl lg:text-[64px] xl:text-[76px] lg:whitespace-nowrap animate-fade-up drop-shadow-[0_4px_18px_rgba(0,0,0,0.65)]"
                    data-testid="hero-title"
                    style={{ animationDelay: "0.15s" }}
                >
                    VEERAS RESORTS &amp; HOSPITALITY
                </h1>

                <div
                    className="mt-10 md:mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-up"
                    style={{ animationDelay: "0.35s" }}
                >
                    <a
                        href={whatsappLink()}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-3 bg-[#25D366] text-white px-7 py-4 md:px-9 md:py-5 rounded-full font-medium text-base md:text-lg shadow-2xl hover:-translate-y-1 transition-transform"
                        data-testid="hero-whatsapp-btn"
                    >
                        <MessageCircle className="h-5 w-5 md:h-6 md:w-6" />
                        Book on WhatsApp
                    </a>
                    <a
                        href={`tel:${BRAND.phone}`}
                        className="inline-flex items-center gap-3 bg-white/95 text-coffee-900 px-7 py-4 md:px-9 md:py-5 rounded-full font-medium text-base md:text-lg shadow-2xl hover:-translate-y-1 transition-transform"
                        data-testid="hero-call-btn"
                    >
                        <Phone className="h-5 w-5 md:h-6 md:w-6" />
                        Call to Book
                    </a>
                </div>
            </div>
        </section>
    );
}
